import axios from 'axios';

const publicClient = axios.create({
  baseURL: window.location.origin
});

/**
 * API client for fetching template files from the public folder.
 */
export const templatesApi = {
  async fetchTemplate(path: string): Promise<string> {
    const response = await publicClient.get<string>(path, {
      responseType: 'text'
    });
    return response.data;
  },

  fetchPowerQueryTemplate(): Promise<string> {
    return this.fetchTemplate('/export/examples/powerQuery_export_script_template.txt');
  },

  fetchPythonTemplate(): Promise<string> {
    return this.fetchTemplate('/export/examples/python_export_script_template.txt');
  }
};
